import { gql } from '@apollo/client';
import { SysubFieldsFragment } from '../organisation/fragments';
import { SongFieldsFragments } from '../song/fragments';

export const UserInviteFieldsFragment = gql`
  fragment UserInviteFields on UserInvite {
    id
    organisationRef
    organisationName
  }
`;

export const UserFieldsFragment = gql`
  fragment UserFields on User {
    id
    avatar
    email
    firstname
    surname
    company
    accessToken
    refreshToken
    tokenExpires
    roles
    subjects
    minAge
    maxAge
    isValidated
    ootaId
    activeSysub
    activeTrial
    trialDateFrom
    trialDateUntil
    validationRequired
    loginCount
    categories
    playsPast30Days
    playsThisMonth
    isAdmin
    oswVisible
    questions
    sysubs {
      ...SysubFields
    }
    invites {
      ...UserInviteFields
    }
    marketingConsent
  }
  ${SysubFieldsFragment}
  ${UserInviteFieldsFragment}
`;

export const UserLicenceFieldsFragment = gql`
  fragment UserLicenceFields on Licence {
    song {
      id
    }
  }
`;
